import type {
  MouseEvent as ReactMouseEvent,
  SyntheticEvent,
} from "react";

const exclusiveTableMenuSelector = [
  "details.multi-filter",
  "details.column-menu",
  "details.document-more-filters",
].join(",");

function closeOtherTableMenus(current: HTMLDetailsElement) {
  if (!current.matches(exclusiveTableMenuSelector)) return;
  const scope = current.closest(".table-toolbar") ?? document;
  scope
    .querySelectorAll<HTMLDetailsElement>(exclusiveTableMenuSelector)
    .forEach((menu) => {
      if (menu !== current && menu.open) menu.open = false;
    });
}

export function handleExclusiveTableMenuToggle(
  event: SyntheticEvent<HTMLDetailsElement>,
) {
  if (event.currentTarget.open) closeOtherTableMenus(event.currentTarget);
}

export function handleExclusiveTableMenuClickCapture(
  event: ReactMouseEvent<HTMLElement>,
) {
  if (!(event.target instanceof Element)) return;
  const menu = event.target.closest("summary")?.parentElement;
  if (menu instanceof HTMLDetailsElement && !menu.open)
    closeOtherTableMenus(menu);
}
